<template>
  <v-menu class="base-menu" v-bind="$attrs">
    <template #activator="{ props }">
      <button v-bind="props" plain class="v-btn--active px-0">
        <slot name="menu-activator" />
      </button>
    </template>
    <v-list class="transparent pa-0 inherit--text menu-list">
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        class="menu-items pa-0 inherit--text body-2"
      >
        <router-link
          v-if="item.path && !item.disabled"
          :class="`d-flex w-100 align-center text-decoration-none inherit--text px-4 text-capitalize inherit--font justify-start d-flex align-center ${item.color}--hover-text`"
          :to="{ ...item }"
          style="min-height: inherit"
        >
          <v-icon
            color="inherit"
            size="large"
            v-if="iconPosition === 'left'"
            class="mr-3"
            :icon="item.icon"
          />
          {{ item.label }}
          <v-icon v-if="iconPosition === 'right'" class="ml-2" :icon="item.icon" />
        </router-link>
        <BaseButton
          v-else
          variant="plain"
          :disabled="item.disabled"
          :class="`inherit--text inherit--font v-btn--active py-0 px-4 menu-btn flex-grow-1 justify-start text-${item.color}`"
          :left-icon="iconPosition === 'left' ? item.icon : ''"
          :right-icon="iconPosition === 'right' ? item.icon : ''"
          @click="handleMenuItemClick(item, index)"
        >
          <span class="mx-2" style="margin-left: 10px !important">{{ item.label }}</span>
        </BaseButton>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script setup lang="ts">
import { VMenu, VList, VListItem } from 'vuetify/components'
import BaseButton from './BaseButton.vue'

defineProps<{
  items: {
    icon?: string
    label: string
    action?: () => void
    path?: string
    query?: any
    color: string
    disabled?: boolean
  }[]
  iconPosition?: string
}>()
const emit = defineEmits(['change'])

const handleMenuItemClick = (
  item: { icon?: string; label: string; action?: () => void },
  index: number
) => {
  if (item.action) item.action()
  else emit('change', item)
}
</script>
<style scoped lang="scss">
.menu-btn {
  min-height: inherit;
}
.secondary_blue--hover-text:hover {
  color: #69cdff !important;
}
.status_negative--hover-text:hover {
  color: var(--v-status_negative-base) !important;
}
.v-btn--active:not(.v-btn--disabled) {
  opacity: 1;
}
</style>
